import { createRouter, createWebHashHistory } from 'vue-router'
import NProgress from 'nprogress'
import { appRoutes } from './routes'
import { useUserStore } from '@/stores/user'
import { visitApi } from '@/api'

NProgress.configure({ showSpinner: false })

const router = createRouter({
  history: createWebHashHistory(),
  routes: [...appRoutes],
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach(async (to, _from, next) => {
  NProgress.start()
  const userStore = useUserStore()

  // 已登录用户访问 guest-only 页面（如登录页），跳转首页
  if (to.meta.guestOnly && userStore.isLoggedIn) {
    NProgress.done()
    return next('/')
  }

  // 需要登录的页面
  if (to.meta.requiresAuth && !userStore.isLoggedIn) {
    NProgress.done()
    return next({ path: '/auth/login', query: { redirect: to.fullPath } })
  }

  // 需要管理员权限
  if (to.meta.requiresAdmin && (!userStore.isLoggedIn || !userStore.isAdmin)) {
    NProgress.done()
    return next(userStore.isLoggedIn ? '/' : { path: '/auth/login', query: { redirect: to.fullPath } })
  }

  next()
})

router.afterEach((to) => {
  NProgress.done()
  // 更新页面标题
  document.title = to.meta.title ? `${to.meta.title} — jannyjanny.cn` : 'jannyjanny.cn'
  // 上报访问统计（异步、静默）
  visitApi.report(to.fullPath)
})

export default router
